<template>
  <span
    class="regular-12 badge w-100 m-2"
    :class="colorClass"
    :style="colorStyle"
    v-if="!edit"
    v-on:dblclick="
      edit = true;
      this.$refs.imp2.search.focus();
    "
  >
    {{ value[row?.label] }}
  </span>
  <v-select
    v-else
    v-model="value"
    :options="row?.values"
    label="name"
    ref="imp2"
    v-on:focusout="edit = false"
    :dropdown-should-open="() => edit"
    append-to-body
  />
</template>

<script>
export default {
  name: "CrmStatusTag",
  props: {
    id: Number,
    row: [Object, Array],
    itemType: String,
    modelValue: [Object, Array, Number, String],
    extraRow: [Object, Array, Number, String],
  },
  data() {
    return {
      value: this.modelValue,
      edit: false,
    };
  },
  computed: {
    color() {
      if (this.row.type === "object") {
        if (this.value?.color !== undefined) {
          return this.value?.color;
        }
      }
      if (
        this.row.type === "enum" &&
        this.row.values?.length > 0 &&
        Array.isArray(this.row.values)
      ) {
        const element = this.row.values.find(
          (d) => d[this.row.selectKey] === this.value
        );
        if (element?.color !== undefined) {
          return element?.color;
        }
      } else if (typeof this.row.values === "object") {
        return this.row.values[this.value]?.color;
      }
      return null;
    },
    colorClass() {
      if (!this.color) return null;

      // If starts with # → do NOT use as class
      if (this.color.startsWith("#")) {
        return null;
      }

      return this.color;
    },

    colorStyle() {
      if (!this.color) return null;

      // If starts with # → use inline background
      if (this.color.startsWith("#")) {
        return {
          background: this.color,
        };
      }

      return null;
    },
  },
  watch: {
    value() {
      this.$emit("update:modelValue", this.value);
      this.$emit("update", this.value);
      this.$emit("change", this.value);
      this.edit = false;
    },
    modelValue() {
      this.value = this.modelValue;
    },
  },
  emits: ["update:modelValue", "change"],
};
</script>
